import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-notification-modal',
  template: `
    <div class="modal-header">
      <div class="modal-title">
        <fa-icon [icon]="['fas', 'envelope-circle-check']" [fixedWidth]="true" class="mr-2"></fa-icon>
        {{ title | translate }}
      </div>
    </div>
    <div class="modal-body">
      <p>{{ message | translate }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="activeModal.close()">
        {{ okText | translate }}
      </button>
    </div>
  `
})
export class NotificationModalComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() okText: string;

  constructor(public activeModal: NgbActiveModal) { }
}
